import { lazy, useState } from 'react'
import { useNVModal } from '@nv/components'
import { AdminVoterAuthService, VoterAuthService } from '@nv/services'
import { useTranslation } from 'react-i18next'
import QRCode from './qr_code/QRcode'
import SecurityQuestion from './security_question/SecurityQuestion'
import styles from './ChangeQRCode.module.scss'
const SuccessQrUpdated = lazy(() => import('@nv/lazy-loadable/lib/modals/SuccessQrUpdated'))

export const ChangeQRCode = ({ admin }) => {
  const { t } = useTranslation()
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState('')
  const [securityCode, setSecurityCode] = useState('')
  const [verificationCode, setVerificationCode] = useState('')
  const [factorSid, setfactorSid] = useState('')
  const { NVModal, openModal } = useNVModal()

  const onSubmitSecurityCode = async () => {
    let result
    if (admin) result = await AdminVoterAuthService.regenerateAuthAppQRCode(securityCode)
    else result = await VoterAuthService.regenerateAuthAppQRCode(securityCode)
    if (result.success) {
      setQrCodeDataUrl(result.qrCodeDataUrl)
      setfactorSid(result.factorSid)
    }
  }

  const onSubmitVerificationCode = async () => {
    try {
      let result
      if (admin) result = await AdminVoterAuthService.verifyRegenerateAuthAppQRCode(verificationCode, factorSid)
      else result = await VoterAuthService.verifyRegenerateAuthAppQRCode(verificationCode, factorSid)
      if (result.success) openModal()
      return result
    } catch (error) {
      return { success: false }
    }
  }

  return (
    <>
      <NVModal>
        <SuccessQrUpdated admin={admin} />
      </NVModal>

      <div className={styles['container']}>
        <span className={styles['title']}>{t('auth.qrCode.regen')}</span>

        <div className={styles['body']}>
          {!qrCodeDataUrl ? (
            <SecurityQuestion onSubmit={onSubmitSecurityCode} code={securityCode} setCode={setSecurityCode} view='MyAccount' />
          ) : (
            <QRCode
              qrCodeDataUrl={qrCodeDataUrl}
              code={verificationCode}
              setCode={setVerificationCode}
              onSubmit={onSubmitVerificationCode}
            />
          )}
        </div>
      </div>
    </>
  )
}
